/* eslint-disable import/no-cycle */
import { ENV } from '@shared/config';
import type { ServerReviewRatingsResponse, ReviewRatings } from '@shared/types';

export async function getReviewRatings(noteId: string): Promise<ReviewRatings> {
  const requestLink = `${ENV.API}/review_ratings/${noteId}`;

  try {
    const { getClientNoCache } = await import('@shared/server-utils');
    const noCache = await getClientNoCache();
    const res = await fetch(requestLink, {
      cache: noCache ? 'no-store' : undefined,
      next: noCache
        ? undefined
        : {
            revalidate: 5,
            tags: [`review-ratings-${noteId}`, 'ALL_REVIEW_RATINGS'],
          },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}, statusText: ${res.statusText}`);
    }

    const response = (await res.json()) as ServerReviewRatingsResponse;
    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Ошибка получения рейтингов отзывов на сервере:', {
      noteId,
      url: requestLink,
      details: error instanceof Error ? error.message : String(error),
    });
    return {
      rating_avg: 0,
      rating_cnt: 0,
      ratings: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
    };
  }
}


